import React from 'react';
import { icons } from 'seal-ui-components';
import { SwitchButton as Button, SwitchButtonWrapper } from './SwitchButton.style';

const SwitchButton = ({ children, ...props }) => {
    const { setOption, option, toggleAuthType, id, index, hasSSO, isCheckingSSO } = props;

    const SwitchButtonHandler = input => {
        if (option.section === input) return;
        setOption(() => ({
            ...option,
            section: input,
            lastLoginSection: input
        }));
        toggleAuthType(input, id);
    };
    return (
        <SwitchButtonWrapper>
            <Button
                id={`sso_login_tab_${index}`}
                onClick={() => SwitchButtonHandler(children[0])}
                active={option.section.toLowerCase() === children[0].toLowerCase()}
                type="button"
                disabled={!hasSSO || isCheckingSSO}
            >
                {isCheckingSSO ? <icons.LoadingMediumIcon /> : children[0]}
            </Button>
            <Button
                id={`credentials_login_tab_${index}`}
                onClick={() => SwitchButtonHandler(children[1])}
                active={option.section.toLowerCase() === children[1].toLowerCase()}
                type="button"
            >
                {children[1]}
            </Button>
        </SwitchButtonWrapper>
    );
};

export default SwitchButton;
